import { colorsPalettes } from "@similarweb/styles";

export const INDUSTRY_AVERAGE_KEY = "Group Average";
export const ADDITIONAL_METRICS = {
    [INDUSTRY_AVERAGE_KEY]: {
        key: INDUSTRY_AVERAGE_KEY,
        color: colorsPalettes.carbon[200],
        title: "conversion.category.metrics.average",
        label: "conversion.category.metrics.average.label",
        tooltip: "conversion.category.metrics.average.tooltip",
    },
};
